import { useState, useEffect, useCallback } from 'react';
import ReportsService from '@/services/reportsService';
import { toast } from 'react-hot-toast';

const useKOTTimingAnalysis = (initialFilters = {}) => {

  const [data, setData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [branchSummary, setBranchSummary] = useState([]);
  const [total, setTotal] = useState(0);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [filters, setFilters] = useState({
    period: '',
    startDate: '',
    endDate: '',
    kitchenStationId: '',
    categoryId: '',
    offset: 0,
    limit: 50,
    ...initialFilters
  });

  const fetchKOTTimingAnalysis = useCallback(async (overrideFilters = {}) => {
    try {
      setLoading(true);
      setError(null);

      const finalFilters = {
        ...filters,
        ...overrideFilters
      };

      const response = await ReportsService.getKOTTimingAnalysis(finalFilters);

      setSummary(response?.summary || null);
      setBranchSummary(response?.branchSummary ?? []);
      setData(response?.data || []);
      setTotal(response?.total || response?.data?.length || 0);

    } catch (err) {
      console.error('Failed to fetch KOT Timing Analysis:', err);
      setError(err);
      toast.error('Failed to load KOT timing report');
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    fetchKOTTimingAnalysis();
  }, [fetchKOTTimingAnalysis]);

  return {
    data,
    summary,
    branchSummary,
    total,
    loading,
    error,
    filters,
    setFilters,
    refresh: fetchKOTTimingAnalysis
  };
};

export default useKOTTimingAnalysis;
